import { isEmpty } from "validate.js";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
export class ShinjoEditViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.nyukyokeiyakuNo = data.nyukyokeiyakuNo;
        this.bukknName = data.buknName;
        this.kouza = new KouzaViewModel(data.kouza);
        this.workPlace = new WorkPlaceViewModel(data.workPlace);
        this.emergencyContact = new EmergencyContactViewModel(data.emergencyContact);
        this.kyojushas = data.kyojushas.map((x, index) => new KyojushasViewModel(x, index));
        this.car = new CarViewModel(data.car);
        this.insurance = new InsuranceViewModel(data.insurance);
        this.isMma = data.isMma;
    }
    nyukyokeiyakuNo = -1;
    bukknName = "";
    kouza = new KouzaViewModel();
    workPlace = new WorkPlaceViewModel();
    emergencyContact = new EmergencyContactViewModel();
    kyojushas = [];
    car = new CarViewModel();
    insurance = new InsuranceViewModel();
    isMma = false;
}
export class KouzaViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.bankCd = data.bankCd;
        this.bankName = data.bankName;
        this.bansCd = data.bansCd;
        this.bansName = data.bansName;
        this.kouzaSb = data.kouzaSb;
        this.kouzaNo = data.kouzaNo;
        this.kouzaName = data.kouzaName;
        this.kouzaKana = data.kouzaKana;
    }
    model = null;
    bankCd = null;
    bankName = "";
    bansCd = null;
    bansName = "";
    kouzaSb = null;
    kouzaNo = null;
    kouzaName = "";
    kouzaKana = "";
}
export class WorkPlaceViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.workplaceName = data.workplaceName;
        this.yearsOfService = data.yearsOfService;
        this.workplaceTel = data.workplaceTel;
        this.workplacePostcode = data.workplacePostcode;
        this.address1 = data.address1;
        this.address2 = data.address2;
        this.address3 = data.address3;
    }
    model = null;
    workplaceName = "";
    yearsOfService = null;
    workplaceTel = "";
    workplacePostcode = "";
    address1 = "";
    address2 = "";
    address3 = "";
}
export class EmergencyContactViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.name = data.name;
        this.dateOfBirth = data.dateOfBirth;
        this.tel = data.tel;
        this.postCode = data.postCode;
        this.address1 = data.address1;
        this.address2 = data.address2;
        this.address3 = data.address3;
        this.workplaceName = data.workplaceName;
        this.yearsOfService = data.yearsOfService;
        this.workplaceTel = data.workplaceTel;
        this.workplacePostcode = data.workplacePostcode;
        this.workplaceAddress1 = data.workplaceAddress1;
        this.workplaceAddress2 = data.workplaceAddress2;
        this.workplaceAddress3 = data.workplaceAddress3;
    }
    model = null;
    name = "";
    dateOfBirth = "";
    tel = "";
    postCode = "";
    address1 = "";
    address2 = "";
    address3 = "";
    workplaceName = "";
    yearsOfService = null;
    workplaceTel = "";
    workplacePostcode = "";
    workplaceAddress1 = "";
    workplaceAddress2 = "";
    workplaceAddress3 = "";
}
export class KyojushasViewModel {
    constructor(data = null, index = 0) {
        if (!data) {
            return;
        }
        this.name = data.name;
        this.relationship = data.relationship;
        this.dateOfBirth = data.dateOfBirth;
        this.tel = data.tel;
        this.index = index;
    }
    name = "";
    relationship = "";
    dateOfBirth = "";
    tel = "";
    index = 0;
}
export class CarViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.manufacturer = data.manufacturer;
        this.carModel = data.carModel;
        this.carColor = data.carColor;
        this.displacement = data.displacement;
        this.registrationNumber = data.registrationNumber;
    }
    model = null;
    manufacturer = "";
    carModel = "";
    carColor = "";
    displacement = null;
    registrationNumber = "";
}
export class InsuranceViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.insuranceCompany = data.insuranceCompany;
        this.insuranceType = data.insuranceType;
        this.contractStartDate = data.contractStartDate;
        this.contractEndDate = data.contractEndDate;
    }
    model = null;
    insuranceCompany = "";
    insuranceType = "";
    contractStartDate = "";
    contractEndDate = "";
    get hasSettings() {
        return (!isNullOrUndefined(this.insuranceCompany) ||
            !isEmpty(this.insuranceCompany) ||
            !isNullOrUndefined(this.insuranceType) ||
            !isEmpty(this.insuranceType) ||
            !isNullOrUndefined(this.contractStartDate) ||
            !isEmpty(this.contractStartDate) ||
            !isNullOrUndefined(this.contractEndDate) ||
            !isEmpty(this.contractEndDate));
    }
}
